import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id E84472BF-7730-4700-B468-E5096FD65531
 * name bed-king-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed-king-outline.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const BedKingOutlineIcon = createSvgIcon(<><path d="M20 10V7A2 2 0 0 0 18 5H6A2 2 0 0 0 4 7V10A2 2 0 0 0 2 12V17H3.33L4 19H5L5.67 17H18.33L19 19H20L20.67 17H22V12A2 2 0 0 0 20 10M13 7H18V10H13M6 7H11V10H6M20 15H4V12H20Z" /></>, 'BedKingOutlineIcon');
export default BedKingOutlineIcon